import * as React from 'react';
import * as PropTypes from 'prop-types';

import '../common/css/reset.css';
import '../common/css/cmn_layout.css';
import '../common/css/cmn_style.css';
import '../css/login.css';
import { Field, reduxForm, FormProps, InjectedFormProps } from 'redux-form';

interface CustomFormProps extends FormProps<InjectedFormProps, {}> {
  auth: any;
  authActions?: any;
  signForm: any;
  dialogActions?: any;
}

class SignForm extends React.Component<CustomFormProps, {}> {
  static propTypes = {
    auth: PropTypes.any.isRequired,
    authActions: PropTypes.any.isRequired,
    signForm: PropTypes.any.isRequired
  };

  private nameInput: any;

  componentDidMount() {
    // nameにフォーカスさせる
    this.nameInput.getRenderedComponent().focus();
  }

  componentWillMount() {
    // 認証状態ならリダイレクトさせる
    if (this.props.auth.isAuthenticated === true) {
      window.location.href = '/admin.html';
    }
  }

  componentDidUpdate() {
    // 認証状態ならリダイレクトさせる
    if (this.props.auth.isAuthenticated === true) {
      window.location.href = '/admin.html';
    }
  }

  handleChangeId(event: any) {
    // DO SOMETHING
  }

  handleChangePassword(event: any) {
    // DO SOMETHING
  }

  handleSubmit(event: React.FormEvent<HTMLInputElement|HTMLFormElement>) {
    // log in
    event.preventDefault();
    if (typeof(this.props.authActions) === 'undefined' || typeof(this.props.signForm) === 'undefined') {
      return;
    }

    // undefinedになってた時に最低から文字にしてcognite側で判断させる
    const username = this.props.signForm.username || '';
    const password = this.props.signForm.password || '';

    this.props.authActions.signIn(
      username,
      password,
      (res: any, message: string) => {
        if (res === false) {
          alert(message);
        }
      }
    );
  }

  render() {
    return (
      <form>
        <table className="loginForm">
        <tbody>
          <tr>
            <th>施設アカウント</th>
            <td>
              <Field
                id="accountid"
                name="username"
                component="input"
                type="text"
                placeholder="ID" 
                required={true}
                autoFocus={true}
                withRef={true}
                ref={(input: any) => { this.nameInput = input; }}
                onChange={(event) => this.handleChangeId(event)}
              />
            </td>
          </tr>
          <tr>
            <th>パスワード</th>
            <td>
              <Field
                id="password"
                name="password"
                component="input"
                type="password"
                placeholder="Password" 
                required={true}
                autoFocus={true}
                withRef={true}
                onChange={(event) => this.handleChangePassword(event)}
              />
            </td>
          </tr>

          <tr>
            <th>&nbsp;</th>
            <td>
              <input
                type="button"
                className="btnStyle01"
                id="login"
                value="ログイン"
                onClick={event => this.handleSubmit(event)}
              />
            </td>
          </tr>
        </tbody>
        </table>
        {/* <div id="message" className="alert" style={{display: this.state.showAlert ? 'block' : 'none' }} /> */}
      </form>
    );
  }
}

export default reduxForm({
  // configureStoreのformとの連携
  form: 'signForm'
})(SignForm as any);



// WEBPACK FOOTER //
// ./src/components/SignForm.tsx